<template>

    <div class="details" :style="`left: ${distance}`" v-show="showDetailFlag">
        <FenceAlarm v-if="showAlarmFence" :alarmData="alarmData" @quitModal="quitModal" />
        <a-modal :title="$t('global.alarmHandle')" v-model="processModel" :width="'40%'"  @ok="handleOk">
            <a-textarea v-model="annotation" :placeholder="$t('global.alarmHandleDescription')" />
        </a-modal>
        <a @click="closeDetail" style="z-index:2000;width:10px;height:10px;position:absolute;top:16px;right:2%;cursor:pointer;" >
            <img src="@assets/point_close.png" align="right" />
        </a>

        <a-tabs v-model="activeKey" class="home-detail-tabs" style="height:100%;width: 100%;" @change="onTabChange">
            <a-tab-pane :tab="$t('home.personInfo')" key="entity">
              <DetailInfo v-if="titles.length > 0 && entityInfos && activeKey === 'entity' && entityDetail" :titles="titles" :infos="entityInfos" />
              <span v-else style="padding-left:20px">{{$t('home.noData')}}</span>
            </a-tab-pane>

            <a-tab-pane :tab="$t('home.deviceInfo')" key="device">
              <DetailDevice v-if="devices && devices.length > 0 && activeKey === 'device' && entityDetail" :devices="devices" />
                <span v-else style="padding-left:20px">{{$t('home.noData')}}</span>
            </a-tab-pane>

            <a-tab-pane :tab="$t('home.health')" key="health"  style="height:220px" v-if="info && (info.capbility_heartrate || info.capbility_step)">
                <div style="z-index:2000;width:340px;height:10px;position:absolute;top:56px;left:2%;">
                    <span style="float:left">{{$t('global.selectDate')}}：</span>
                    <a-range-picker style="float:left;width:200px" v-model="times" size="small" @change="onDateChange" :allowClear="false" :ranges="timeOption">
                        <a-icon slot="suffixIcon"/>
                    </a-range-picker>
                </div>

                <div style="width:50%;height:100%;float:left" id="stepChart"></div>
                <div style="width:50%;height:100%;float:right" id="heartChart"></div>
                <!-- <div style="width:50%;height:100%;float:right" id="healthChart"></div> -->
                <!-- <div style="width:50%;height:100%;float:right" id="bloodPressureChart"></div> -->
            </a-tab-pane>

            <a-tab-pane :tab="$t('home.alarms')" key="alarm">
                <div style="margin-left:20px;margin-right:20px;margin-top: -5px;margin-bottom:5px">
                    <a-spin :spinning="isLoading">
                        <a-table :pagination="pagination" :showHeader="true" :columns="columns" :dataSource="alarms" size="small" @change="pageChange">
                            <template slot="alarmName" slot-scope="text, record">
                                <div>
                                <i class="icon-alarm icon-lg">
                                    <zx-icon :type="computedAlarmIcon(record.alarmCode)" />
                                </i>
                                {{$t(`alarm.${text}`)}}
                                </div>
                            </template>
                            <template slot="level" slot-scope="text">
                                <a-tag color="blue" v-if="text == 1">{{$t('global.event')}}</a-tag>
                                <a-tag color="yellow" v-if="text == 2">{{$t('global.noramlAlarm')}}</a-tag>
                                <a-tag color="orange" v-if="text == 3">{{$t('global.importantAlarm')}}</a-tag>
                                <a-tag color="red" v-if="text == 4">{{$t('global.fearfulAlarm')}}</a-tag>
                            </template>
                            <template slot="date" slot-scope="text">
                                <span>{{text && alarmTimeFormat(text)}}</span>
                            </template>
                            <template slot="status" slot-scope="text, record">
                              <a-tag @click="disposeAlarm(record)" color="red" v-if="text == 0">{{$t('global.undisposed')}}</a-tag>
                              <a-tooltip v-if="text == 1" placement="top" :title="record.annotation" arrowPointAtCenter>
                                <a-tag color="green">{{$t('global.processed')}}</a-tag>
                              </a-tooltip>
                            </template>
                            <template slot="showAlarm" slot-scope="text, record">
                                <a-button v-if="record.alarmCode === 31" @click="showAlarmInfo(record, info.entity)" type="danger" size="small">{{$t('global.showAlarmPosition')}}</a-button>
                            </template>
                        </a-table>
                    </a-spin>
                </div>
            </a-tab-pane>

            <!-- <a-tab-pane :tab="$t('home.hook')" key="log">
              <DetailLogs v-if="activeKey === 'log' && entityDetail" :entityLogs="entityLogs" :entityId="entityId" />
            </a-tab-pane> -->
        </a-tabs>
    </div>
</template>

<script>
    const echarts = require('echarts')
    import FenceAlarm from '@/views/alarm/FenceAlarmModal'
    import {TransForm} from '@/assets/js/transform.js'
    import config from '@/config'
    import DetailLogs from './details/logs'
    import DetailInfo from './details/info'
    import DetailDevice from './details/device'
    import bus from '../../bus/bus'
    import moment from 'moment'
    import {
        computedAlarmIcon
    } from '../../utils/homeFn'

    export default {
        name:"ZMapDetail",
        components: {
            FenceAlarm,
            DetailLogs,
            DetailInfo,
            DetailDevice
        },
        props:['titles'],
        data () {
            return {
                processModel: false,
                annotation: '',
                annotationId: '',
                entityDetail: false,
                // 人员入组时间
                entityRegTime: '',
                isLoading: false,
                // 是否显示围栏告警模态框
                showAlarmFence: false,
                // 围栏告警的信息
                alarmData: '',
                // 绝对定位左边框的距离
                distance: '400px',
                info: '',
                showDetailFlag: false,
                activeKey: null,
                entityInfos: null,
                entityLogs: [],
                devices: [],
                times: null,
                stepData: [],
                heartData: [], 
                heartChartInstance: null, 
                temperatureData:[],
                systolicPressureData:[],
                diastolicPressureData:[],
                bloodOxygenData:[],
                entityId: null,
                pagination: {
                    pageSize: 4,
                    current: 1,
                    total : 0,
                    showTotal: '',
                    showQuickJumper:true,
                    size: 'small',
                },
                alarms: [],
                // timeOption:{
                //     '近一日': [moment().subtract(1, 'days'),moment()],
                //     '近一周': [moment().subtract(6, 'days'), moment()],
                //     '近一月': [moment().subtract(30, 'days'), moment()],
                // }
            }
        },
        methods:{
            moment,
            computedAlarmIcon,
            // 点击处理单条告警
            disposeAlarm(record) {
              // console.log(record)
              this.annotationId = record.id
              this.processModel = true
              // this.selectedRows = [record]
              // this.selectedRowKeys = [record.key]
              // this.batchProcess()
            },
            handleOk () {
              // this.annotation.trim()
              if (this.annotation.trim()) {
                // put http
                let params = [{
                  id: this.annotationId,
                  annotation: this.annotation.trim()
                }]
                this.$http.post(config.api.alarm_process_url, params).then((response) => {
                  if (response.code == 0) {
                    // 重新请求数据
                    this.queryEntityAlarms()
                    this.annotation = ''
                    this.annotationId = ''
                    this.processModel = false
                    this.$notification.success({
                      message: this.$t('global.alarmHandleSuccess')
                    })
                  } else {
                    this.$notification.error({message: response.desc})
                  }
                })
              } else {
                this.$notification.error({message: this.$t('global.alarmHandleDescription')})
              }
            },
            showAlarmInfo (record, entity) {
                // console.log(record.attr)
                let newRecord = Object.assign(record, {
                    entity
                })
                // 显示弹出框
                this.alarmData = newRecord
                this.showAlarmFence = true
            },
            quitModal () {
                this.showAlarmFence = false
            },
            transToBd09(coord_type, lng, lat) {
                var tmpLat = +lat;
                var tmpLng = +lng;
                var tmp;
                if (coord_type == 'wgs84' || coord_type == 'WGS84') {
                    tmp = TransForm.wgs84tobd09(tmpLng, tmpLat);
                } else if (coord_type == 'gcj02' || coord_type == 'GCJ02') {
                    tmp = TransForm.gcj02tobd09(tmpLng, tmpLat);
                } else {
                    tmp = [tmpLng, tmpLat];
                }
                tmp = [tmp[0].toFixed(6), tmp[1].toFixed(6)];
                return tmp;
            },
            getAddress(record){
                let lnglat = this.transToBd09(record.coordType,record.lng,record.lat)
                var geoc = new window.BMap.Geocoder()
                var pt = new window.BMap.Point(lnglat[0],lnglat[1])
                let address = null
                let _this = this
                geoc.getLocation(pt, function (rs) {
                    if (rs.address !== '') {
                        address  = rs.address;
                    }else if ((rs.addressComponents.city !== '') && (rs.addressComponents.country !== '')){
                        address  = rs.addressComponents.city + ', ' + rs.addressComponents.country;
                    }
                    // if(address != null && address.length > 10){
                    //     address = address.substring(0,12) + '...'
                    // }
                    record.address = address
                    _this.alarms = [..._this.alarms]
                    // console.log(_this.alarms)
                })
            },
            alarmTimeFormat(timestamp) {
                return moment(timestamp * 1000).format('YYYY-MM-DD HH:mm:ss')
            },
            onTabChange(){
                if(this.activeKey == 'entity' || this.activeKey == 'device' || this.activeKey == 'log'){
                    this.queryEntityDetail()
                }
                if(this.activeKey == 'health'){ 
                     if(this.info.capbility_blood_pressure){
                        this.queryHealthDetailPlus()
                    }else{
                        this.queryHealthDetail()
                    }
                }
                if(this.activeKey == 'alarm'){
                    this.queryEntityAlarms()
                }
            },
            onDateChange(){ 
                if(this.info.capbility_blood_pressure){
                    this.queryHealthDetailPlus()
                }else{
                    this.queryHealthDetail()
                }
            },
            timeFormat(timestamp) {
                return moment(timestamp * 1000).format('YYYY-MM-DD')
            },
            closeDetail() {
                this.showDetailFlag = false
            },
            showDetail(info,key){
                this.showDetailFlag = true
                this.activeKey = key
                this.info = info
                console.log("showDetail",info)
                this.entityId = info.id
                this.times = [moment().subtract(6, 'days'), moment()]
                if(key == 'entity' || key == 'device'|| key == 'log'){
                    this.queryEntityDetail()
                }
                if(key == 'health'){
                    if(info.capbility_blood_pressure){
                        this.queryHealthDetailPlus()
                    }else{
                        this.queryHealthDetail()
                    }
                }
                if(key == 'alarm'){
                    this.queryEntityAlarms()
                }
            },
            queryEntityDetail(){
              this.entityDetail =false
                this.$http.get(config.api.entity_detail_url + "/" + this.entityId).then((response) => {
                    if(response.code == 0){
                        // console.log(response)
                        this.entityDetail = true
                        this.entityInfos = response.result.entity
                        this.entityRegTime = response.result.entity.alterGroupTimestamp
                        this.devices = response.result.devices
                        this.entityLogs = response.result.summary
                        // console.log(this.entityInfos)
                    }
                })
            },
            queryHealthDetail(){
                console.log("queryHealthDetail");
                let startTime = (this.times[0].valueOf()/1000).toFixed(0)
                let endTime = (this.times[1].valueOf()/1000).toFixed(0)
                this.$http.get(config.api.entity_health_data_url + "/" + this.entityId + '?startTime=' + startTime + '&endTime=' + endTime).then((response) => {
                    if(response.code == 0){
                        // console.log(response)
                        this.stepData = response.result.step
                        this.heartData = response.result.heart.filter((item) => {
                            return item.value != -1
                        })
                        // console.log(this.heartData)
                        this.setStepChart()
                        this.setHeartChart()
                    }
                })
            },
            queryHealthDetailPlus(){
                console.log("queryHealthDetailPlus");
                let startTime = (this.times[0].valueOf()/1000).toFixed(0)
                let endTime = (this.times[1].valueOf()/1000).toFixed(0)
                this.$http.get(config.api.entity_health_data_url + "/" + this.entityId + '?startTime=' + startTime + '&endTime=' + endTime).then((response) => {
                    if(response.code == 0){
                        // console.log(response)
                        this.stepData = response.result.step
                        this.heartData = response.result.heart.filter((item) => {
                            return item.value != -1
                        })
                        this.temperatureData = response.result.temperature
                        this.systolicPressureData = response.result.bloodPressure.systolicPressure
                        this.diastolicPressureData = response.result.bloodPressure.diastolicPressure
                        this.bloodOxygenData = response.result.bloodOxygen
                        // console.log(this.heartData)
                        this.setStepChart()
                        this.setHeartChartPlus() 
                    }
                })
            },
            queryEntityAlarms(currentPage=1){
                this.isLoading = true
                let searchParams = {
                    entityId: this.entityId,
                    pageSize: 4,
                    currentPage
                }
                this.$http.post(config.api.alarm_all_url, searchParams).then((response) => {
                    if(response.code == 0){
                        // console.log(response)
                        this.alarms =  response.result.resultList
                        // console.log(this.data)
                        this.pagination.total = response.result.page.totalSize
                        this.pagination.showTotal = () => this.$t('global.totalRecords', {num: response.result.page.totalSize})
                        this.alarms.map((alarm) => {
                            alarm.address = alarm.address ? alarm.address : this.getAddress(alarm)
                        })
                        this.isLoading = false
                    }
                }).catch((err) => {
                    // console.log(err)
                    this.isLoading = false
                })
            },
            pageChange (page) {
                this.queryEntityAlarms(page.current)
                this.pagination.current = page.current
            },
            // 销毁图表实例的方法
            destroyChartInstance(chartInstance) {
                if (chartInstance) {
                    chartInstance.dispose();
                }
            },
            
            setHeartChart(){
                let data = []
                let titleData = []
                this.heartData.map(function(item){
                    titleData.push(item.date);
                    data.push(item.value)
                })
                this.destroyChartInstance(this.heartChartInstance);
                this.heartChartInstance = echarts.init(document.getElementById('heartChart'));
                let option = {
                    color: ['#ca8622'],
                    tooltip : {
                        trigger: 'axis',
                        axisPointer: {
                            label: {
                                backgroundColor: '#fff'
                            }
                        }
                    },
                    grid: {
                        top: '22%',
                        left: '4%',
                        right: '4%',
                        bottom: '18%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        data: titleData
                    },
                    yAxis: {
                        name: this.$t('home.heartRate'),
                        type: 'value'
                    },
                    series: [{
                        data: data,
                        type: 'line',
                        smooth: true
                    }]
                };
                this.heartChartInstance.setOption(option);
                window.removeEventListener('resize', this.handleHeartChartResize);
                this.handleHeartChartResize = () => {
                    if (this.heartChartInstance) {
                        this.heartChartInstance.resize();
                    }
                };
                window.addEventListener('resize', this.handleHeartChartResize);
            },
            setHeartChartPlus(){
                let data1 = []
                let data2 = []
                let data3 = []
                let data4 = [] 
                let data5 = []
                let titleData = []
                this.heartData.map(function(item){
                    titleData.push(item.date);
                    data1.push(item.value)
                })
                this.temperatureData.map(function(item){
                    data2.push(item.value)
                })
                this.diastolicPressureData.map(function(item){
                    data3.push(item.value)
                })
                this.systolicPressureData.map(function(item){
                    data4.push(item.value)
                })
                this.bloodOxygenData.map(function(item){
                    data5.push(item.value)
                }) 
                 
                this.destroyChartInstance(this.heartChartInstance); 
                this.heartChartInstance = echarts.init(document.getElementById('heartChart'));
                let option = { 
                    tooltip : {
                        trigger: 'axis',
                        axisPointer: {
                            label: {
                                backgroundColor: '#fff'
                            }
                        }
                    },
                    grid: {
                        top: '22%',
                        left: '4%',
                        right: '4%',
                        bottom: '18%',
                        containLabel: true
                    },
                    legend: {
                        data:[this.$t('home.heartRate'),this.$t('home.temperature'),this.$t('home.diastolicPressure'),this.$t('home.systolicPressure'),this.$t('home.bloodOxygen')]
                    },
                    xAxis: {
                        type: 'category',
                        data: titleData
                    },
                    yAxis: {
                        name: this.$t('home.vitalSigns'),
                        type: 'value'
                    },
                    series: [{
                        name: this.$t('home.heartRate'),
                        data: data1,
                        type: 'line',
                        smooth: true
                    },
                    {
                        name: this.$t('home.temperature'),
                        data: data2,
                        type: 'line',
                        smooth: true
                    },
                    {
                        name: this.$t('home.systolicPressure'),
                        data: data3,
                        type: 'line',
                        smooth: true
                    },
                    {
                        name: this.$t('home.diastolicPressure'),
                        data: data4,
                        type: 'line',
                        smooth: true
                    },
                    {
                        name: this.$t('home.bloodOxygen'),
                        data: data5,
                        type: 'line',
                        smooth: true
                    }
                ]
                };
                this.heartChartInstance.setOption(option);
                 
                window.removeEventListener('resize', this.handleHeartChartResize);
                 
                this.handleHeartChartResize = () => {
                    if (this.heartChartInstance) {
                        this.heartChartInstance.resize();
                    }
                };
                window.addEventListener('resize', this.handleHeartChartResize);
            }, 
            
            setStepChart(){
                let data = []
                let titleData = []
                this.stepData.map(function(item){
                    titleData.push(item.date);
                    data.push(item.sum)
                })
                let stepChart = echarts.init(document.getElementById('stepChart'));
                let option = {
                    color: ['#ca8622'],
                    tooltip : {
                        trigger: 'axis',
                        axisPointer: {
                            label: {
                                backgroundColor: '#fff',
                                color: '#fff'
                            }
                        }
                    },
                    grid: {
                        top: '22%',
                        left: '4%',
                        right: '4%',
                        bottom: '18%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        data: titleData
                    },
                    yAxis: {
                        name: this.$t('home.stepNumber'),
                        type: 'value'
                    },
                    series: [{
                        data: data,
                        type: 'line',
                        smooth: true
                    }]
                };
                stepChart.setOption(option);

                window.addEventListener('resize', function () {
                    stepChart.resize();
                });
            }
        },
        computed: {
            // distance () {
            //     return '400px'
            // }
            timeOption () {
              return {
                [this.$t('global.today')]: [moment().startOf('day'), moment()],
                [this.$t('global.lastThreeDays')]: [moment().subtract('days', 2).startOf('day'), moment()],
                [this.$t('global.lastSevenDays')]: [moment().subtract('days', 6).startOf('day'), moment()],
                [this.$t('global.lastThirtyDays')]: [moment().subtract('days', 29).startOf('day'), moment()],
                [this.$t('global.thisWeek')]: [moment().startOf('week'), moment()],
                [this.$t('global.thisMounth')]: [moment().startOf('month'), moment()]
              }
            },
            columns () {
              return [
                    {
                        "title": this.$t('global.alarmType'),
                        "key": "alarmName",
                        "dataIndex": "alarmType",
                        "scopedSlots": {
                            "customRender": "alarmName"
                        }
                    },
                    {
                        "title": this.$t('global.alarmTime'),
                        "key": "occurTime",
                        "dataIndex": "occurTime",
                        "scopedSlots": {
                            "customRender": "date"
                        }
                    },
                    {
                        "title": this.$t('global.alarmLevel'),
                        "key": "alarmLevel",
                        "dataIndex": "level",
                        "scopedSlots": {
                            "customRender": "level"
                        }
                    },
                    {
                        "title": this.$t('global.alarmStatu'),
                        "key": "status",
                        "dataIndex": "status",
                        "scopedSlots": {
                            "customRender": "status"
                        },
                        // filters: [{
                        //     text: '未处理',
                        //     value: '0',
                        // }, {
                        //     text: '已处理',
                        //     value: '1',
                        // }],
                        // onFilter: (value, record) => record.status == value,
                    },
                    {
                        "title": this.$t('global.alarmPosition'),
                        "key": "address",
                        "dataIndex": "address"
                    },
                    // {
                    //     "title": this.$t('global.alarmDescription'),
                    //     "key": "message",
                    //     "dataIndex": "message"
                    // },
                    {
                        "title": this.$t('global.alarmAction'),
                        "key": "alarmName-actions",
                        "dataIndex": "alarmType",
                        "scopedSlots": {
                            "customRender": "showAlarm"
                        },
                    },
                ]
            }
        },
        mounted () {
            // 根据抽屉组件的打开和关闭动态改变详情框的宽度
            bus.$on('onDrawerChange', (data) => {
                if (data) {
                    this.distance = '400px'
                } else {
                    this.distance = '50px'
                }
            })
            // 
            // console.log(this.titles)
        },
        beforeDestroy () {
          bus.$off('onDrawerChange')
          this.destroyChartInstance(this.heartChartInstance);
          window.removeEventListener('resize', this.handleHeartChartResize);
        }
    }
</script>

<style scoped lang="less">
@import '../../theme/page.less';
    .details {
        width: auto;
        position: absolute;
        height:400px;
        bottom:10px;
        left:400px;
        right: 1px;
        z-index: 10000;
        overflow: auto;
        .home-detail-tabs {
            background-color: #fff;
            // .liner-gradient-body;
        }
        .empty {
            width: 70px;
            height: 98px;
            border: 1px solid #ccc;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            color: #999;
            font-size: 11px;
        }
    }
</style>
